import { AuditFormDto } from './auditForm.dto';
import { AuditFormFrequencyDto } from './auditFormFrequency.dto';
import { AuditFormScheduleStatusDto } from './auditFormScheduleStatus.dto';
import { AuditFormStatusDto } from './auditFormStatus.dto';
import { BaseDto } from '../base.dto';
import { UserDto } from '../user.dto';

export class AuditFormNewScheduleRequestDto extends BaseDto {
  auditForm: AuditFormDto;

  auditFormStatus: AuditFormStatusDto;

  // @IsArray()
  // @ArrayMinSize(1)
  // @Type(() => UserDto)
  users: UserDto[];

  // @IsDate()
  // @Type(() => Date)
  startDate: Date;

  frequency: AuditFormFrequencyDto;

  // @IsInt()
  // @Min(1)
  noOfQuestions: number;

  auditFormScheduleStatus: AuditFormScheduleStatusDto;

  // @IsInt()
  scheduledDateAsInt: number;
}
